var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demo_wrapper"},[_c('h4',[_vm._v("应用案例")]),_c('el-image',{staticStyle:{"width":"100%","height":"500px"},attrs:{"src":require('../assets/imgs/demo.png'),"fit":'fit'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }